import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CommonRzmService} from './common-rzm.service';
import {AuthService} from './auth.service';
import {UtilService} from '../util/util.service';
import {AddressVO} from '../generate/AddressVO';

@Injectable({
  providedIn: 'root'
})
export class CountriesListService extends CommonRzmService {

  private _countries: any[] = [];

  constructor(@Inject(HttpClient) http, @Inject('env') environment, @Inject(AuthService) auth, private util: UtilService) {
    super(http, environment, auth);
  }

  get countriesList(): any[] {
    return this._countries;
  }

  load() {
    if (this._countries.length <= 2) {
      this.getResponseUnAuthenticatedRequest<any[]>(this.getRestEndPoint() + '/countries').subscribe(data => {
        this._countries.push({countryName: "Select a Country", countryCode: "select"});
        this._countries.push(...data);
        this._countries.push({countryName: "Other", countryCode: "other"});
      }, error => {
        console.log(error);
      }, () => {

      });
    }
  }


  buildAddressFromForm(formValue: any): AddressVO {
    let countryName: string = this.getCountryName(formValue);
    let countryCode: string = this.getCountryCode(formValue);

    let address: AddressVO = {};
    address.streetAddress = this.util.returnNullIfEmpty(formValue.streetAddress);
    address.city = this.util.returnNullIfEmpty(formValue.city);
    address.state = this.util.returnNullIfEmpty(formValue.state);
    address.countryName = this.util.returnNullIfEmpty(countryName);
    address.countryCode = this.util.returnNullIfEmpty(countryCode);
    address.postalCode = this.util.returnNullIfEmpty(formValue.postalCode);

    return address;
  }


  public getCountryCode(formValue: any, countryField?: string) {
    if(!countryField){
      countryField = 'countryName';
    }

    if (formValue[countryField] === "select" || formValue[countryField] === "other") {
      return null;
    }
    return formValue[countryField];

  }

  public getCountryName(formValue: any, countryField?: string, otherCountryField?: string) {
    if(!countryField){
      countryField = 'countryName';
    }

    if(!otherCountryField){
      otherCountryField = 'otherCountry';
    }

    if (formValue[countryField] === "select") {
      return null;
    } else if (formValue[countryField] === "other") {
      return formValue[otherCountryField];
    }

    return this._countries.find(countryName => countryName.countryCode == formValue[countryField]).countryName;
  }


  public getCountry(otherCountry: boolean, address: AddressVO): any {
    console.log(address);

    if (!otherCountry && !address.countryCode) {
      if(!address.countryName){
        console.log("select");
        return "select";
      }else{
        console.log("other");
        return "other";
      }
    }else{
      if (!otherCountry && address.countryCode != null) {
        return address.countryCode;
      }
      if (otherCountry && address.countryCode != null) {
        return "";
      } else {
        return address.countryName;
      }
    }

  }
}
